/* eslint-disable linebreak-style */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import { Redirect, Route, Switch } from 'react-router-dom';

import MusicalMap from './components/map/MusicalMap';
import './style/Global.css';
import ReactGA from 'react-ga';

const GOOGLE_ANALYTICS_ID='UA-160572511-1';

function initializeAnalytics(){
	// console.log('load analytics');
	ReactGA.initialize(GOOGLE_ANALYTICS_ID)
	ReactGA.pageview(window.location.pathname + window.location.search);
}

class App extends Component {
	componentDidMount() {
		initializeAnalytics();

	}

	render() {
		

		return (
			<>
				<Helmet titleTemplate="%s - Library of Anthems of the World." defaultTitle="Library of Anthems of the World.">
					<meta charSet="utf-8" />
					<meta name="description" content="Library of Anthems of the World." />
				</Helmet>
				<Route 
					exact path='/' 
					component={MusicalMap}
				/>
				<Switch>
					{/* <Route exact path="/" render={() => (
						<Redirect to="/map" />
					)} /> */}
					<Route exact path='/explore' component={MusicalMap}
					/>
					<Route exact path='/explore/:parameterCountry'
						component={MusicalMap}
					/>				
				</Switch>
			</>

		);
	}
}

export default App;
